<template>
  <div id="admin">
    <div class="row cont">
      <div class="image col-xl-12">
        <span>Benvenuto, Admin</span>
        <router-link :to="{name: 'login'}">
          <img class="imageLogo" src="../../static/image/admin/logoutlogo.png" @click="deleteToken"/>
        </router-link>
      </div>
      <div class="row col-xl-12 titoli">
        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 d-none d-sm-block">Tipologia</div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 d-none d-sm-block">Nome</div>
        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 d-none d-sm-block">Quantità disponibile</div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 d-none d-sm-block">Disponibile dal</div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 d-none d-sm-block">Prezzo</div>
      </div>
      <div class="row vini">
        <div class="col-xl-12 wines" v-for="(wine, index) in wines" v-bind:style="(index % 2 === 0) ? 'background-color: #383839' : 'background-color: #202127'">
          <singlewinemanager :wine="wine"></singlewinemanager>
        </div>
      </div>
      <div class="row codici">
        <smartbox-code></smartbox-code>
      </div>
    </div>
  </div>
</template>

<script>
  import Singlewinemanager from "./SingleWineManager"
  import Bus from './Bus'
  import SmartboxCode from "./SmartboxCode";

  export default {
    name: "admin",
    components: {SmartboxCode, Singlewinemanager},
    data() {
      return {
        myHeight: window.innerHeight,
        wines: [],
        codes: [],
        qntyProd: 0,
        available: ''
      }
    },
    updated () {
      if (!localStorage.getItem('token')) {
        this.$router.push({name: 'login'})
      }
    },
    mounted: function () {
      this.getAllWines()
      if(!this.isValid()) this.$router.push({name: 'login'})
    },
    methods: {
      isValid: function () {
        let token = localStorage.getItem('token')
        if (token && token !== null) {
          let strArray = token ? token.split('.') : []
          let str = strArray.length > 1 ? atob(strArray[1]) : '{}'
          let tokenJson = JSON.parse(str)
          tokenJson.sub = tokenJson.sub ? JSON.parse(tokenJson.sub) : {}
          let exp = tokenJson.exp
          return exp > parseInt((Date.now() / 1000) + 60)
        } else {
          return false
        }
      },
      getAllWines: function () {
        this.$http.get('/ws-shop/products/all/', {params: {'lang': 'ita'}}).then(response => {
          this.wines = response.body.data
        })
      },
      deleteToken: function (){
        localStorage.removeItem('token');
        Bus.$emit('admin')
      }
    }
  }
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";

  #admin {
    background-color: @darkGray;
    color: white;
    letter-spacing: 1px;
    text-align: center;
    .set-font(@size: 18px);
    .mx-input {
      color: white;
      background-color: grey;
      border: 1px solid lightgray;
    }
    .mx-input-append {
      background-color: grey;
    }
    .mx-calendar-icon {
      color: white;
    }
    ::placeholder {
      color: white;
      opacity: 1;
    }
    a {
      color: grey;
    }
    a:hover
    {
      color: grey;
    }
    .page-item.active .page-link {
      color: white !important;
      background-color: @myOrange;
      border-color: @borderOrange;
    }
    .row{
      margin-right: 0px;
      margin-left: 0px;
      input[type=number] {
        text-align: center;
        font-weight: 700;
        outline: none;
      }
      input[type=dste] {
        text-align: center;
        font-weight: 700;
        outline: none;
      }
    }
    .cont {
      padding: 140px;
      padding-top: 75px;
      padding-bottom: 0px;
      .image{
        text-align: right;
        padding-bottom: 40px;
        padding-top: 30px;
        .imageLogo{
          cursor: pointer;
          width: 3%;
        }
      }
      .titoli {
        color: @lightGold;
        padding: 10px;
      }
      .vini{
        border: 1px solid white;
        .wines{
          .testoRiepilogo{
            padding: 10px;
            .nomeTyp{
              text-align: left;
            }
            .nomeVino{
              text-align: center;
            }
            .quantity {
              .quantità {
                width: 30%;
                text-align: center;
                background-color: grey;
                color: white;
                border-color: lightgray;
              }
            }
            .disponibilita{
              .date{
                width: 50%;
                text-align: center;
                background-color: grey;
                color: white;
                border-color: lightgray;
              }
            }
          }
        }
      }
      .codici{
        margin: auto;
        margin-top: 50px;
        margin-bottom: 50px;
        width: 100%;
      }
      .botton {
        width: 200px;
        background-color: @myOrange;
        border-color: @borderOrange;
        text-align: center;
        letter-spacing: 1px;
        margin-left: 88%;
        margin-top: 50px;
        margin-bottom: 50px;
        .set-font()
      }
    }

  }

  @media (max-width: 767px){
    #admin {
      height: auto !important;
      .set-font(@size: 16px);
      .mx-input-wrapper {
        width: 120px;
      }
      .mx-input {
      }
      .mx-input-append {
      }
      .mx-calendar-icon {
      }
      ::placeholder {
      }
      .cont {
        padding: 10px;
        padding-top: 75px;
        .image{
          text-align: right;
          padding-bottom: 10px;
          padding-top: 15px;
          .imageLogo{
            cursor: pointer;
            width: 13%;
          }
        }
        .titoli {
          padding: 10px;
        }
        .vini{
          .wines{
            padding-right: 0px;
            padding-left: 0px;
            .testoRiepilogo{
              padding: 10px;
              .nomeVino{
                padding-left: 13%;
              }
              .quantity {
                .quantità {
                  width: 60%;
                }
              }
              .disponibilita{
                .date{
                  width: 50%;
                }
              }
              .price1{
                padding: 5px;
              }
            }
          }
        }
        .botton {
          width: 200px;
          letter-spacing: 1px;
          margin-left: 50%;
          margin-top: 50px;
          margin-bottom: 50px;
          .set-font()
        }
      }

    }
  }

  @media (min-width: 768px) and (max-width: 1366px){
    #admin {
      .set-font(@size: 16px);
      .mx-input-wrapper {
        width: 120px;
      }
      .mx-input {
      }
      .mx-input-append {
      }
      .mx-calendar-icon {
      }
      ::placeholder {
      }
      .cont {
        padding: 10px;
        padding-top: 75px;
        .image{
          text-align: right;
          padding-bottom: 10px;
          padding-top: 15px;
          .imageLogo{
            cursor: pointer;
            width: 5%;
          }
        }
        .titoli {
          padding: 10px;
        }
        .vini{
          .wines{
            padding-right: 0px;
            padding-left: 0px;
            .testoRiepilogo{
              padding: 10px;
              .nomeVino{
                padding-left: 5%;
              }
              .quantity {
                .quantità {
                  width: 60%;
                }
              }
              .disponibilita{
                .date{
                  width: 50%;
                }
              }
              .price1{
                padding: 5px;
              }
            }
          }
        }
        .botton {
          width: 200px;
          letter-spacing: 1px;
          margin-left: 50%;
          margin-top: 50px;
          margin-bottom: 50px;
          .set-font()
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin.vue